import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";

const defaultPageConfig = {
  USE_PAGINATION_API: false
}

const PageDataFetcher = ({
  stateKey,
  fetcher,
  querySetter,
  pageConfig = defaultPageConfig,
  children,
  ...props
}) => {
  const dispatch = useDispatch();
  const query = queryString.parse(props.location.search);
  const defaultQuery = useSelector((state) => state[stateKey].defaultQuery);
  const { USE_PAGINATION_API } = pageConfig;

  const handlePaginationAPI = useCallback(() => {
    if (query) {
      dispatch(querySetter(query)).then(() =>
        dispatch(
          fetcher({
            ...defaultQuery,
            ...query,
          })
        )
      );
    } else {
      dispatch(fetcher(defaultQuery));
    }
  }, [dispatch, query, defaultQuery, fetcher, querySetter]);

  const handleNormalFetching = useCallback(() => {
    if (query) {
      dispatch(querySetter(query)).then(() => dispatch(fetcher(query)));
    } else {
      dispatch(fetcher());
    }
  }, [dispatch, query, fetcher, querySetter]);

  const initialDataFetcher = useCallback(
    (defaultQuery) =>
      defaultQuery ? handlePaginationAPI() : handleNormalFetching(),
    [handlePaginationAPI, handleNormalFetching]
  );

  React.useEffect(() => {
    initialDataFetcher(USE_PAGINATION_API ? defaultQuery : false);
  }, [initialDataFetcher, defaultQuery, USE_PAGINATION_API]);

  return <>{children}</>;
};

export { PageDataFetcher };
